<script>
    // From https://github.com/pespantelis/vue-typeahead
    // Adjusted to work with Axios
    import debounce from 'lodash-es/debounce';

    export default {

    data() {
        return {
            items: null,
            query: '',
            current: -1,
            loading: false,
            selectFirst: false,
            queryParamName: 'q',
        };
    },

    computed: {
        hasItems() {
            return this.items !== null && this.items.length > 0;
        },

        isEmpty() {
            return ! this.query;
        },

        isDirty() {
            return !! this.query;
        },
    },

    methods: {
        /* eslint-disable func-names */
        update: debounce(function () {
            if (! this.query) {
                this.reset();
                return;
            }

            if (this.minChars && this.query.length < this.minChars) {
                return;
            }

            this.loading = true;

            this.fetch().then((response) => {
                if (this.query) {
                    let data = response.data;
                    data = this.prepareResponseData ? this.prepareResponseData(data) : data;
                    this.items = this.limit ? data.slice(0, this.limit) : data;
                    this.current = -1;
                    this.loading = false;

                    if (this.selectFirst) {
                        this.down();
                    }
                }
            });
        }, 200),

        fetch() {
            if (! this.src) {
                return console.warn('You need to set the `src` property');
            }

            const src = this.queryParamName
                ? this.src
                : this.src + this.query;

            const params = this.queryParamName
                ? ({ [this.queryParamName]: this.query, ...this.data })
                : this.data;

            return axios.get(src, { params });
        },

        reset() {
            this.items = null;
            this.query = '';
            this.loading = false;
        },

        setActive(index) {
            this.current = index;
        },

        activeClass(index) {
            return {
                'is-active': this.current === index,
            };
        },

        hit() {
            if (this.current !== -1) {
                this.onHit(this.items[this.current]);
            }
        },

        up() {
            if (this.current > 0) {
                this.current--;
            } else if (this.current === -1) {
                this.current = this.items.length - 1;
            } else {
                this.current = -1;
            }
        },

        down() {
            if (this.current < this.items.length - 1) {
                this.current++;
            } else {
                this.current = -1;
            }
        },

        onHit() {
            console.warn('You need to implement the `onHit` method');
        },
    },
};
</script>
